import React from 'react';
import { useTranslation } from 'react-i18next';
import OfferPriceGrid from './OfferPriceGrid';
import OfferPageAccordion from './OfferPageAccordion';

function OfferSection() {
  const { t: tr } = useTranslation();
  return (
    <div className="offer-block py-4">
      <div className="offer-section-heading">
        <h2 className="page-title mb-0">{tr('public:ourCourses_75')}</h2>
        <div className="offer-actions">
          <a href="/grafik" className="btn btn-outline-danger font-weight-bold">{tr('public:timetable.checkSchedule')}</a>
          <a href="/signup" className="btn btn-danger font-weight-bold">{tr('public:signUpForClassesToday_78')}</a>
        </div>
      </div>
      <div className="offer-layout">
        <OfferPriceGrid />
        <div className="offer-accordion"><OfferPageAccordion /></div>
      </div>
    </div>
  );
}

export default OfferSection;
